var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListUnordered = function SvgListUnordered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.4 4.8h11.7v1.8H8.4zM5.25 7.05a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7m0 6.3a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7m0 6.21a1.35 1.35 0 1 1 0-2.7 1.35 1.35 0 0 1 0 2.7M8.4 11.1h11.7v1.8H8.4zm0 6.3h11.7v1.8H8.4z"
  })));
};
export default SvgListUnordered;